export enum SearchTab {
    All = "All",
    Mail = "Mail",
    Files = "Files",
    Chats = "Chats",
    People = "People",
    Events = "Events"
}
